import {useEffect} from 'react'
import {Navigate, Routes} from 'react-router-dom'
import {useAuth} from './core/Auth'
import { doLogout } from '../../api'
import { clearCachedData } from './core/AuthHelpers'
import { useAppContext } from '../apps/AppContext'

export function Logout() {

  const {logout} = useAuth()
  useEffect(() => {
    
    logout()
    document.location.reload()
  }, [logout])

  return (
    <Routes>
      <Navigate to='/auth/login' />
    </Routes>
  )
}
